import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ApiHelper } from '~/services/api';

@Component({
    selector: 'app-render-report',
    templateUrl: './render-report.component.html',
    styleUrls: ['./render-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RenderReportComponent implements OnInit {
  reportId: number | null = null;
  transactionId: any = null;
  siteId: number | null = null;

  pdfUrl: SafeResourceUrl | null = null;
  isLoading: boolean = true;
  hasError: boolean = false;
  errorMessage: string = '';

  constructor(
    private route: ActivatedRoute,
    private apiHelper: ApiHelper,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.isLoading = true;
      this.hasError = false;
      this.errorMessage = '';
      
      if (!params || Object.keys(params).length === 0) {
        this.isLoading = false;
        this.hasError = true;
        this.errorMessage = 'No report parameters were provided. Please specify a valid report transaction.';
        return;
      }


      // Check if we can load it using the Angular report-viewer component
      const rawReportId = params['ReportID'] || params['reportId'];
      const rawTransactionId = params['PrimaryID'] || params['transactionId'] || params['primaryId'];
      const rawSiteId = params['siteId'] || params['SiteID'];

      if (rawReportId) {
        this.reportId = parseInt(rawReportId, 10);
        this.transactionId = rawTransactionId || null;
        this.siteId = rawSiteId ? parseInt(rawSiteId, 10) : null;
        this.isLoading = false;
      } else {
        // Fallback to legacy iframe endpoint rendering if no ReportID is supplied
        this.fetchReport(params);
      }
    });
  }

  fetchReport(params: any): void {
    try {
      // Build the backend request URL
      const baseUrl = this.apiHelper.getBaseWithoutApi();
      const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
      const backendUrl = `${cleanBaseUrl}/RenderReport`;

      // Ensure we send isApi=true and api=true to avoid redirect loops
      const queryParams = { ...params, isApi: 'true', api: 'true' };

      // Construct the query string
      const queryString = Object.keys(queryParams)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
        .join('&');

      const fullUrl = `${backendUrl}?${queryString}`;
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);

      // Safety timeout: stop spinner after 20 seconds in case load fails silently
      setTimeout(() => {
        if (this.isLoading) {
          this.isLoading = false;
        }
      }, 20000);
    } catch (e: any) {
      this.isLoading = false;
      this.hasError = true;
      this.errorMessage = e.message || 'An unexpected error occurred while preparing the report.';
    }
  }

  onIframeLoad(): void {
    this.isLoading = false;
  }
}
